import { tokens } from '@fluentui/react-components';
import { themeVar } from '../theme/themeConfig';

export const BRAND = 'var(--moko-brand, #6264a7)';
export const BRAND_LIGHT = 'var(--moko-brand-light, #e8e8f4)';

export const shellVar = (name: string, fallback: string): string =>
  themeVar('shell', name, fallback);

export const navIconColor = (
  iconColor: string | undefined,
  active: boolean
): string => {
  const resting = shellVar('sidebar-icon-color', iconColor ?? 'inherit');
  return active ? shellVar('sidebar-active-icon-color', resting) : resting;
};

export const navItemCss = `
  [data-nav-item] {
    position: relative;
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 9px 12px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 550;
    line-height: 1.5;
    color: ${shellVar('sidebar-text', tokens.colorNeutralForeground1)};
    text-align: left;
    width: 100%;
    border-radius: 7px;
    transition: background 0.15s;
    white-space: nowrap;
  }
  [data-nav-item] svg {
    width: 18px;
    height: 18px;
  }
  [data-nav-item][data-collapsed] {
    justify-content: center;
    padding: 9px 0;
    gap: 0;
  }

  [data-nav-item]:hover {
    background-color: ${shellVar('sidebar-hover-background', BRAND_LIGHT)};
  }
  [data-nav-item][data-active] {
    background-color: ${shellVar('sidebar-active-background', BRAND_LIGHT)};
    color: ${shellVar('sidebar-active-text', BRAND)};
    font-weight: 600;
  }
  [data-nav-item][data-active]::before {
    content: '';
    position: absolute;
    left: -12px;
    top: 8px;
    bottom: 8px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: ${shellVar('sidebar-indicator-color', BRAND)};
  }
  [data-nav-item][data-collapsed][data-active]::before {
    left: -6px;
  }

  [data-nav-section] {
    padding: 14px 10px 6px;
    font-size: 10.5px;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${shellVar('sidebar-muted-text', tokens.colorNeutralForeground3)};
  }
  [data-nav-section][data-collapsed] {
    height: 1px;
    margin: 8px 6px;
    padding: 0;
    background: ${shellVar('sidebar-border', tokens.colorNeutralStroke2)};
  }

  [data-sidebar-toggle] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
    border: none;
    border-radius: ${tokens.borderRadiusMedium};
    background: none;
    cursor: pointer;
    font-size: 20px;
    color: ${shellVar('sidebar-muted-text', tokens.colorNeutralForeground2)};
    transition: background 0.15s;
  }
  [data-sidebar-toggle]:hover {
    background-color: ${shellVar(
      'sidebar-hover-background',
      tokens.colorSubtleBackgroundHover
    )};
    color: ${shellVar('sidebar-text', tokens.colorNeutralForeground2Hover)};
  }
`;

export const headerCss = `
  [data-layout-avatar-button] {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 8px 4px 4px;
    border: none;
    border-radius: ${tokens.borderRadiusCircular};
    background: none;
    cursor: pointer;
    transition: background 0.15s;
  }
  [data-layout-avatar-button]:hover {
    background-color: ${tokens.colorSubtleBackgroundHover};
  }

  [data-layout-header]::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -2px;
    height: 2px;
    pointer-events: none;
    background: linear-gradient(
      90deg,
      ${shellVar('topbar-accent', 'transparent')} 0,
      ${shellVar('topbar-accent', 'transparent')} 64px,
      transparent 64px
    );
  }
`;
